module.exports = __webpack_public_path__ + "static/lightning-card-nested-1ec9c239cce5f0a09966ceee6f450c29.png";